/* eslint-disable ember/no-classic-components, ember/require-tagless-components */
import { action } from '@ember/object';
import Component from '@ember/component';

export default class PostActions extends Component {
  @action
  handleEdit() {
    this.edit(this.post);
  }
}
